import logo from '../../img/logo.png';
import { getUserByEmail } from '../../api/usersModule/getters';
import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../utils/Contexts/UserContext';

interface Props {
	signOut: () => void;
	user: {
		attributes: {
			email: string;
			'custom:project': string;
		};
	};
}

const HomePage: React.FC<Props> = () => {
	
	const [userObject, setUserObject] = useState<{ UserName: string }>({
		UserName: '',
	});
	const user = useContext(UserContext);

	useEffect(() => {
		getUserByEmail(
			user.attributes.email,
			setUserObject,
			user.attributes['custom:project']
			
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCapitalizedString = (string: string) => {
		return string.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
	};

	return (
		<>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					width: '100%',
					maxHeight: '100vh',
					overflowY: 'scroll',
					justifyContent: 'center',
					position: 'relative', // agregar posición relativa al contenedor
				}}
			>
				<h1 style={{ textAlign: 'center' }}>
					<strong>
						Le damos la bienvenida a nuestro Software<br />
						Usuario: {getCapitalizedString(userObject.UserName)}
					</strong>
				</h1>
				<img
					src={logo}
					alt='logo'
					width={400}
					height={400}
					className='img-fluid'
					style={{
						marginBottom: '2rem',
					}}
				/>
				<div>
					<p style={{
					marginBottom: '0.1rem', // ajustar el margen inferior
					}}>
						{/* "No es posible resolver los problemas de hoy con las soluciones de
						ayer" */}
					</p>
					<p style={{
						textAlign: 'right', // alinear el texto a la derecha
					}}>
					{/* - Roger Van Oech */}
					</p>
				</div>
				{/* <img
					src={Logo}
					alt='logo'
					width={200} // ajustar el tamaño según lo necesite
					height={200}
					className='img-fluid'
					style={{
						position: 'absolute',
						bottom: 10, // ajustar la separación del borde inferior
						right: 10, // ajustar la separación del borde derecho
					}}
				/> */}
			</div>
		</>
	);
};

export default HomePage;
